import { configureStore } from '@reduxjs/toolkit';
import jobStatusReducer from './jobStatusSlice';
import userDetailsReducer from './userDetailsSlice'

const store = configureStore({
  reducer: {
    userDetails: userDetailsReducer,
    jobStatus: jobStatusReducer,
  },
});

export default store;
